import { useQuery } from '@tanstack/react-query';

export function useProjectsDashboardsProjectsReportsDashboardReportQuery({
  params = {},
  queryOptions,
}) {
  return useQuery({
    queryKey: [
      'projectsReports',
      'dashboardReports',
      'projectsDashboards',
      params,
    ],
    queryFn: async () => {
      const response = await axios.post(
        '/projects_dashboards/projects_reports/dashboard_reports',
        { dashboard_report: params },
      );

      return response.data;
    },
    ...queryOptions,
  });
}
